import styled from 'styled-components';
import React from 'react';
import { AuthToken } from 'modules/auth/authToken';
import { useTypedSelector } from 'types/global';
import { selectAppToken, selectEnvironment } from 'modules/global';
import config from '../config';
import localhost from '../config/localhost';

const $Container = styled.div`
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  background: linear-gradient(90deg, #005e3f, #003926);
  border-radius: 100px;
  padding: 8px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

const $Label = styled.span`
  color: #2ed59d;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const $Message = styled.span`
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.3px;
  flex: 1;
`;

const V2DashboardBanner = () => {
  const environment = useTypedSelector(selectEnvironment);
  const appToken = useTypedSelector(selectAppToken);

  const handleTryNewDashboardClick = () => {
    const accessToken = AuthToken.get();

    const isLocalEnv = process.env.REACT_APP_V2_ENV === 'localhost';
    const url = isLocalEnv ? localhost.v2DashboardUrl : config.v2DashboardUrl;

    window.open(
      `${url}?${new URLSearchParams({
        access_token: accessToken || '',
        environment,
        app_token: appToken,
      })}`,
      '_blank',
    );
  };

  return (
    <$Container
      data-cy="try-new-badge-dashbord"
      style={{ cursor: 'pointer' }}
      onClick={handleTryNewDashboardClick}
    >
      <$Label>NEW</$Label>
      <$Message>v2 Dashboard</$Message>
    </$Container>
  );
};

export default V2DashboardBanner;
